import { useLang } from "../context/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee");
  const row = [...items];
  return (
    <div className="hairline-t hairline-b overflow-hidden bg-[#050607] py-4" data-testid="brand-marquee">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="mono text-[11px] tracking-[0.3em] text-[#999995] px-8">{item}</span>
                <span className="w-1 h-1 rotate-45 bg-[#D1C7BD]/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
